export default __webpack_public_path__ + "static/Derek Hutchinson-2314e50d3ad83917ec132897533b3645.jpg";